import { max } from "date-fns";
import { AutogenLayoutdpScanned } from "./autogen/AutogenLayoutdpScanned";

export class dpScanned extends AutogenLayoutdpScanned {

  override async onLoad() {
    //Scanned Today
    await this.sourceBolimgd.search({ bimd_scandt: "t" });
    this.textboxToday.text = this.sourceBolimgd.actualRowCount.toString();
    //Scanned Yesterday
    await this.sourceBolimgd.search({ bimd_scandt: "t-1" });
    this.textboxYesterday.text = this.sourceBolimgd.actualRowCount.toString();
    //Past 7 days
    await this.sourceBolimgd.search({ bimd_scandt: "t-7:t" });
    this.textboxWeek.text = this.sourceBolimgd.actualRowCount.toString();
    //Total
    await this.sourceBolimgd.search({ });
    this.textboxTotal.text = this.sourceBolimgd.actualRowCount.toString();
  }

}
